// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cn-category-cards__content{grid-gap:var(--size-xl);display:grid;gap:var(--size-xl);grid-template-columns:repeat(4,minmax(0,1fr))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
